import { render } from "./ProfilePreferencesTab.vue?vue&type=template&id=76794aa6&scoped=true&ts=true"
import script from "./ProfilePreferencesTab.vue?vue&type=script&lang=ts"
export * from "./ProfilePreferencesTab.vue?vue&type=script&lang=ts"

import "./ProfilePreferencesTab.vue?vue&type=style&index=0&id=76794aa6&scoped=true&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76794aa6"]])

export default __exports__